import { browserTracingIntegration, init } from "@sentry/remix"
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from "@remix-run/react"
import { startTransition, StrictMode, useEffect } from "react"
import { hydrateRoot } from "react-dom/client"

init({
  enabled: process.env.NODE_ENV === "production",
  dsn: "https://abc05c34409e605b46fa2f530619fbd4@o4508654057029632.ingest.us.sentry.io/4510155132633089",
  tracesSampleRate: 0.01,
  replaysOnErrorSampleRate: 1,
  replaysSessionSampleRate: 0.01,
  enableLogs: true,

  integrations: [
    browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
  ],
})

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  )
})
